import Model from './Model'

export default class Park extends Model {
  resource()
  {
    return 'parks'
  }

  toFilterOptions(models) {
    // Returns an array of FilterDefinitionOption based on the received models
    if (!Array.isArray(models)) return [];
    return models.map(model => ({
      value: String(model.id),
      label: model.ownerable.name + ' - ' + model.name + (model.active_equipments_count != null ? ' (' + model.active_equipments_count + ')' : '')
    }));
  }
}